document.addEventListener('DOMContentLoaded', () => {
  // Get theme settings
  const settings = window.themeVariables.settings;
  
  // Get current market
  const currentMarket = settings.currentMarketSm;
  
  console.log('Current market:', currentMarket);
  console.log('Settings:', settings);
  
  // Function to format price based on settings
  function formatPrice(priceElement) {
    if (!priceElement || !priceElement.hasAttribute('data-price-formatted')) return;
    
    // Get the price from the data attribute (in cents)
    const priceInCents = parseInt(priceElement.getAttribute('data-price-formatted'));
    
    // Use the formatMoney function to format the price with market-specific settings
    const formattedPrice = formatMoney(priceInCents, settings.moneyFormat, currentMarket);
    
    // Update the price element
    priceElement.textContent = formattedPrice;
  }
  
  // Format all prices on page load
  const priceElements = document.querySelectorAll('[data-price-formatted]');
  if(settings.priceFunctionEnabled && priceElements.length > 0) {
    priceElements.forEach(formatPrice);
  }
  
  // Listen for variant changes to reformat prices
  // document.addEventListener('variant:change', () => {
  //   const priceElements = document.querySelectorAll('[data-price-formatted]');
  //   priceElements.forEach(formatPrice);
  // });
});



// Map market names to country codes
const marketToCountryCode = {
  'xoxowildhearts.myshopify.com': {
    'nl': 'nl',
    'spanje': 'es',
    'duitsland-1': 'de',
    'duitsland': 'fr',
    'verenigd': 'gb',
  },
  'bwjecommerce.myshopify.com': {
    'nl': 'nl',
    'spanje': 'es',
    'duitsland': 'de',
    'frankrijk': 'fr',
    'uk': 'gb',
    'verenigde-staten': 'us',
    'italie': 'it'
  },
}

function formatMoney(cents, format = "", market = null) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  
  // Get market-specific settings or fall back to default settings
  const currencySymbol = getMarketCurrencySymbol(market);
  const currencyPlacement = getMarketCurrencyPlacement(market);
  
  console.log('Market:', market);
  console.log('Currency symbol:', currencySymbol);
  console.log('Currency placement:', currencyPlacement);

  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  // Remove any existing currency symbols from the format string
  const cleanFormatString = formatString.replace(/[€$£¥]/g, '');
  const formattedValue = cleanFormatString.replace(placeholderRegex, value);
  
  // Format the final price with currency symbol based on placement
  if (currencyPlacement === 'before') {
    return `${currencySymbol}${formattedValue}`;
  } else {
    return `${formattedValue}${currencySymbol}`;
  }
}

// Helper function to get market-specific currency symbol
function getMarketCurrencySymbol(market) {
  if (!market) return window.themeVariables.settings.chooseCurrencySymbol || '€';
  
  // Convert market name to country code
  const countryCode = marketToCountryCode[Shopify.shop][market.toLowerCase()];
  console.log(`Market: ${market}, Country code: ${countryCode}`);
  
  if (countryCode) {
    // Try to get market-specific setting
    const marketSymbol = window.themeVariables.settings[`${countryCode}_currency_symbol`];
    console.log(`Looking for ${countryCode}_currency_symbol:`, marketSymbol);
    
    if (marketSymbol) return marketSymbol;
  }
  
  // Fall back to default settings
  return window.themeVariables.settings.chooseCurrencySymbol || '€';
}

// Helper function to get market-specific currency placement
function getMarketCurrencyPlacement(market) {
  if (!market) return window.themeVariables.settings.currencyCodePlacement || 'before';
  
  // Convert market name to country code
  const countryCode = marketToCountryCode[Shopify.shop][market.toLowerCase()];
  console.log(`Market: ${market}, Country code: ${countryCode}`);
  
  if (countryCode) {
    // Try to get market-specific setting
    const marketPlacement = window.themeVariables.settings[`${countryCode}_currency_placement`];
    console.log(`Looking for ${countryCode}_currency_placement:`, marketPlacement);
    
    if (marketPlacement) return marketPlacement;
  }
  
  // Fall back to default settings
  return window.themeVariables.settings.currencyCodePlacement || 'before';
}
